import axiosInstance from "../../axios/instance";
import { normalizeToUTC } from "@revbox/helpers-fe";
import { endOfDay, startOfDay } from "date-fns";
import { getToken } from "../../helpers/get-token";

async function getPeriodAvgCPC(currentPeriod, previousPeriod) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;

        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/analytics/revenue/period/avg-cpc', {
            current_period: [startOfDay(normalizeToUTC(currentPeriod[0])).getTime(), endOfDay(normalizeToUTC(currentPeriod[1])).getTime()],
            previous_period: [startOfDay(normalizeToUTC(previousPeriod[0]).getTime()), endOfDay(normalizeToUTC(previousPeriod[1])).getTime()]
        })

        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getPeriodAvgCPC;
